module.exports = __webpack_public_path__ + "public/img/kehuzhaohui.5ff885bd.png";